<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />

        <span class="title_text2">项目发薪</span>
      </div>

      <div class="query_box"></div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="table_loading"></Spin>

        <div class="count_card" @click="click_itax">
          <div>
            <span class="iconfont icongeshui1 iconfukuan2"></span>
          </div>
          <div class="count_title2">员工个税核算</div>
        </div>


        <div class="count_card" @click="click_fukuan">
          <div>
            <span class="iconfont iconfukuan iconfukuan2"></span>
          </div>

          <div class="count_title2">项目发薪申请</div>
        </div>

        <div class="count_card" @click="click_record">
          <div>
            <span class="iconfont iconjilu iconfukuan2"></span>
          </div>

          <div class="count_title2">发薪申请记录</div>
        </div>
        <div class="count_card" @click="click_bufa">
          <div class="count_card_1">
            <span class="iconfont iconxinxiwanshan iconfukuan2"></span>
          </div>
          <div class="count_title2">发薪补发</div>
        </div>
        <div class="count_card" @click="bankcard_baobei_show = true">
          <div class="count_card_1">
            <span class="iconfont iconkaxiangqing iconfukuan2"></span>
          </div>
          <div class="count_title2">异常银行卡报备</div>
        </div>
        <!-- <div class="count_card" @click="click_weituo">
          <div class="count_card_1">
            <span class="iconfont iconshouquanweituoshu1 iconfukuan2"></span>
          </div>
          <div class="count_title2">发薪委托书配置</div>
        </div> -->
      </div>
    </div>

    <Modal v-model="bankcard_baobei_show" :footer-hide="true" title="异常银行卡报备" :width="400">
      <div>
        发薪或添加银行卡出现的三要素异常银行卡，与员工核对后能正常收到款的可在此处报备。报备后正常操作即可。
      </div>
      <div class="bank_baobei_input_div">
        <div class="bank_baobei_input">
          <span>卡类型：</span>

        </div>
        <Select v-model="bankcard_baobei_item.card_type" style="width:200px">
          <Option value="yinhangka">银行卡</Option>
          <Option value="cunzhe">存折</Option>
        </Select>
        <div class="bank_baobei_input">
          <span>姓名：</span>
          <Input v-model="bankcard_baobei_item.name" placeholder="员工姓名" />
        </div>
        <div class="bank_baobei_input">
          <span>身份证号：</span>
          <Input v-model="bankcard_baobei_item.idcard" placeholder="身份证号码" />
        </div>
        <div class="bank_baobei_input">
          <span>银行卡号：</span>
          <Input v-model="bankcard_baobei_item.bankcard_number" placeholder="银行卡号" />
        </div>


      </div>
      <div style="display: flex;justify-content: end;margin-top:20px">
        <Button type="primary" @click="bankcard_baobei_ok">确认报备</Button>
      </div>
    </Modal>

    <Drawer title="发薪委托书配置" :mask-closable="true" v-model="weituo_setting_show" width="90">
      <div>
        <div class="weituo_span">
          <Icon type="md-list" size="20" color='#0466dd' />相关配置
        </div>
        <div class="weituo_switch">
          <div>校验员工发薪委托书：</div>
          <Switch v-model="weituo_status" @on-change="weituo_switch_change">
            <template #open>
              <span>开</span>
            </template>
            <template #close>
              <span>关</span>
            </template>
          </Switch>
        </div>
        <div style="height:10px"></div>
        <div class="weituo_span">
          <Icon type="md-list" size="20" color='#0466dd' />不校验员工委托书
        </div>
        <div class="add_weituo">
          <span class="add_weituo_span">提示：员工不在花名册中，但需要发薪的，可以在此录入信息，添加后不校验发薪委托书</span>

          <Button type="primary" style="font-size:13px;" size="small" @click="click_add_people">
            <Icon type="md-add-circle" />添加员工信息
          </Button>
        </div>
        <div class="table_div">
          <Table size="small" :height="windowHeight - 245" :columns="weituo_columns" :data="weituo_data">
            <template #action="{ row }">
              <Button size=small style="font-size:13px" @click="click_people_update(row)">编辑</Button>
              <Button size=small type="error" style="font-size:13px;margin-left:10px"
                @click="del_people(row)">删除</Button>
            </template>

          </Table>

        </div>

      </div>
    </Drawer>

    <Modal v-model="add_new_people_show" title="录入排除人员的信息" :mask-closable="false" :footer-hide="true" width="400">
      <div class="div_input">
        <div class="div_input_span">
          员工姓名：
        </div>
        <div>
          <Input size="small" v-model="add_new_people_item.name" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          手机号码：
        </div>
        <div>
          <Input size="small" v-model="add_new_people_item.phone" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          身份证号：
        </div>
        <div>
          <Input size="small" v-model="add_new_people_item.idcard" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          银行名称：
        </div>
        <div>
          <Input size="small" v-model="add_new_people_item.bankname" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          银行卡号
        </div>
        <div>
          <Input size="small" v-model="add_new_people_item.bankcard" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="add_confirm">
        <Button type="primary" @click="add_new_people">确认添加</Button>
      </div>

    </Modal>


    <Modal v-model="update_new_people_show" title="排除人员信息更新" :mask-closable="false" :footer-hide="true" width="400">
      <div class="div_input">
        <div class="div_input_span">
          员工姓名：
        </div>
        <div>
          <Input size="small" v-model="update_new_people_item.name" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          手机号码：
        </div>
        <div>
          <Input size="small" v-model="update_new_people_item.phone" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          身份证号：
        </div>
        <div>
          <Input size="small" v-model="update_new_people_item.idcard" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          银行名称：
        </div>
        <div>
          <Input size="small" v-model="update_new_people_item.bankname" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="div_input">
        <div class="div_input_span">
          银行卡号
        </div>
        <div>
          <Input size="small" v-model="update_new_people_item.bankcard" placeholder="请输入..." style="width: 260px" />
        </div>
      </div>
      <div class="add_confirm">
        <Button type="primary" @click="click_people_update_confirm">确认更新</Button>
      </div>

    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "project_payment",

  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      table_loading: false,
      project_id: "",
      project_name: "",
      weituo_setting_show: false,
      weituo_status: false,
      weituo_data: [],
      weituo_columns: [],
      add_new_people_show: false,
      add_new_people_item: {
        name: '',
        phone: '',
        idcard: '',
        bankname: '',
        bankcard: ''
      },
      update_new_people_item: {
        people_id: '',
        name: '',
        phone: '',
        idcard: '',
        bankname: '',
        bankcard: ''
      },
      update_new_people_show: false,

      bankcard_baobei_show: false,
      bankcard_baobei_item: {
        name: "",
        idcard: "",
        bankcard_number: '',
        card_type: 'yinhangka'

      }

    };
  },

  mounted() {
    // var query = this.$router.query;
    // if (query) {
    //   this.project_id = project_id;
    //   this.project_name = project_name;
    // }
    this.window_change()
  },
  methods: {

    bankcard_baobei_ok() {
      var that = this;
      var obj = {
        name: this.bankcard_baobei_item.name,
        idcard: this.bankcard_baobei_item.idcard,
        bankcard_number: this.bankcard_baobei_item.bankcard_number,
        card_type: this.bankcard_baobei_item.card_type

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/error_bankcard_baobei",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_people_update_confirm() {

      var that = this;
      var obj = {
        project_id: this.project_id,
        name: this.update_new_people_item.name,
        phone: this.update_new_people_item.phone,
        idcard: this.update_new_people_item.idcard,
        bankname: this.update_new_people_item.bankname,
        bankcard: this.update_new_people_item.bankcard,
        people_id: this.update_new_people_item.people_id

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/weituoshu_update_pass_people",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_new_people_show = false
            that.get_weituo_setting_info();

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });


    },

    click_people_update(row) {
      this.update_new_people_show = true
      this.update_new_people_item = {
        'name': row.name,
        'people_id': row.id,
        phone: row.phone,
        idcard: row.idcard,
        bankname: row.bankname,
        bankcard: row.bankcard
      }
    },
    del_people(row) {

      var that = this;

      var obj = {
        project_id: this.project_id,
        people_id: row.id
      };
      that.$Modal.confirm({
        title: "提示",
        content: "正在删除，是否继续？",
        onOk: () => {
          http(
            "post",
            process.env.VUE_APP_HOST + "/finance/payment/weituoshu_del_pass_people",
            obj,
            true
          )
            .then((res) => {
              if (res.code == 0) {
                that.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
                that.get_weituo_setting_info();

              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {

              console.log(res, "请求出错");
            });
        },
        onCancel: () => {

        },
      });




    },


    add_new_people() {

      var that = this;
      var obj = {
        project_id: this.project_id,
        name: this.add_new_people_item.name,
        phone: this.add_new_people_item.phone,
        idcard: this.add_new_people_item.idcard,
        bankname: this.add_new_people_item.bankname,
        bankcard: this.add_new_people_item.bankcard,

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/weituoshu_add_pass_people",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.add_new_people_show = false
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_weituo_setting_info();

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });

    },

    click_add_people() {
      this.add_new_people_show = true
    },

    weituo_switch_change(e) {
      console.log(e)

      var that = this;
      var obj = {
        project_id: this.project_id,
        value: e
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/weituoshu_switch_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });
    },

    //获取委托书详情
    get_weituo_setting_info() {
      console.log('获取委托书详情')
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/weituoshu_setting_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.weituo_status = res.data.project_pass_status;
            that.weituo_columns = res.data.people_columns;
            that.weituo_data = res.data.people_list

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });
    },


    //点击发薪委托书配置
    click_weituo() {
      this.weituo_setting_show = true
      this.get_weituo_setting_info()


    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;
      console.log('找开发薪委托')

      // var query = this.$router.query;
      // if (query) {
      //   this.project_id = project_id;
      //   this.project_name = project_name;
      // }
    },

    click_bufa() {
      var path =
        "/finance/payment/bufa?project_name=" +
        this.project_name +
        "&project_id=" +
        this.project_id;
      open_new_page(path);
    },

    click_itax() {
      var path =
        "/finance/itax?project_name=" +
        this.project_name +
        "&project_id=" +
        this.project_id;
      open_new_page(path);
    },

    click_fukuan() {
      console.log(this.project_id);
      var path =
        "/finance/payment?project_name=" +
        this.project_name +
        "&project_id=" +
        this.project_id;
      open_new_page(path);
      //   this.$router.push({
      //     path: "/finance/payment",
      //   });
    },

    click_record() {
      var path =
        "/finance/payment/detail?project_name=" +
        this.project_name +
        "&project_id=" +
        this.project_id;
      open_new_page(path);
    },
    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;
    },
  },
};
</script>

<style scoped>
.bank_baobei_input_div {
  margin-top: 10px;
}

.bank_baobei_input {
  margin-top: 10px;
}

.icongeshui1 {}

.div_input {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.add_confirm {
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
}

.add_weituo_span {
  font-size: 13px;
  padding: 2px 10px;
  border-radius: 3px;
  background-color: #fff3e2;
}

.add_weituo {
  margin-top: 5px;
  display: flex;
  justify-content: space-between
}

.div_input_span {
  font-size: 13px;
  width: 100px;
  flex-shrink: 0;
}

.weituo_span {
  font-size: 14px;
  font-weight: 600;
}

.table_div {
  padding: 10px 0;
}

.weituo_switch {
  margin-top: 10px;
  display: flex;
  padding-left: 20px;
  align-items: center;
}

.iconfukuan2 {
  font-size: 22px;
  color: #0466dd;
}

.left_btn {
  display: flex;
  align-items: center;
}

.is_hexiao_div {
  display: flex;
  align-items: center;
}

.page_1 {
  padding-top: 3px;
  display: flex;
  justify-content: center;
}

.del_jiezhi {
  color: #f10800;
  cursor: pointer;
}

.fafang_time {
  cursor: pointer;
  color: #425dc0;
}

.search_box {
  padding-bottom: 10px;
}

.audit_box2_title {
  margin-bottom: 10px;
}

.audit_box {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.download_box_ts {
  background: #f82323;
  color: #fff;
  padding: 1px 10px;
  font-size: 13px;
  border-radius: 3px;
}

.download_box_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.download_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.table_card_scroll {
  height: calc(100vh - 90px);
  overflow: auto;
  position: relative;
}

.jiezhi_box {
  border-top: 1px dashed #ccc;
  margin: 10px 0 10px 0;
  padding-top: 10px;
}

.create_time {
  font-size: 12px;
  text-align: right;
}

.name {
  font-size: 13px;
  font-weight: 600;
  color: #000;
}

.card_inner {
  font-size: 13px;
  color: #333;
  display: flex;
  align-items: center;
}

.table_card {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  margin-top: 5px;
}

.fafang_receipt {
  color: #0466dd;
}

.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #b8bef7;
  text-align: center;
}

.count_card:hover {
  background: #0466dd;
  color: #fff
}


.count_card:hover .iconfukuan2 {
  color: #fff
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
